module.exports = __webpack_public_path__ + "img/empreendimento-logo-10.e680bc93.png";